/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";

interface Params {
  firebase_uid: any;
  firebase_token: any;
  recycler_uid: string;
  recycler_location_uid: string;
  p1s3e50_imported_contacts_doc_id: string;
}

function deleteImportedContact(
  recycler_uid: string,
  recycler_location_uid: string,
  imported_contacts_doc_id: string,
) {
  return new Promise(function (resolve, reject) {
    let params: Params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
      p1s3e50_imported_contacts_doc_id: imported_contacts_doc_id,
    };

    ajax({
      url: window.G_cloud_p1s3_base_url + "p1s3e50DeleteImportedContact",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,
      success: function (result) {
        let response_data = {
          success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },
      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s3e50.ts",
          class_name: "p1s3e50",
          method_name: "deleteImportedContact",
          error_title: "Failed to delete a consumer import record.",
          error_description: "The server responded with an error when deleting a consumer import record.",
        };

        httpsLogger(error_data);
        reject(error_data);
      },
    });
  });
}

export default deleteImportedContact;
